import { render, staticRenderFns } from "./home-box5.vue?vue&type=template&id=a3645f00&scoped=true&"
import script from "./home-box5.vue?vue&type=script&lang=js&"
export * from "./home-box5.vue?vue&type=script&lang=js&"
import style0 from "./home-box5.vue?vue&type=style&index=0&id=a3645f00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3645f00",
  null
  
)

export default component.exports